import { startApplication } from './utils/startApplication';

startApplication();
